import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  toggle: false,
};

export const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    setToggle: (state, { payload }) => {
      state.toggle = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setToggle } = sidebarSlice.actions;
